import React, { useState, useEffect } from 'react';
import images from '../../../Utils/images';
import CheerioButton from '../../../Components/CheerioButton';
import colors from '../../../Utils/colors';
import { getPixelPages, savePixelConfiguration, getMetaAdsUserInfo, getMetauserBusinessInfo, getMetauserWABusinessInfo, saveFbToken, getLeadPages, saveLeadPageId, delinkFbToken, getAdAccountInsights, getUserApi, saveMetaConfig, getMetaConfig, onboardTwoTierBusiness } from '../../../Services';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { FormControl, Select, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SelectPageModal from '../PixelIntegration/selectPageModal';
import { useNavigate } from 'react-router-dom';

export const MetaAdsManager = () => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [businessId, setBusinessId] = useState('');
    const authtoken = useSelector((state) => state.main.auth_token);
    const localdata = useSelector((state) => state.main.localdata);

    function NotFoundPage() {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-white p-6">
                <div className="relative w-full max-w-2xl mx-auto text-center">
                    <div className="flex flex-col items-center mb-8">
                        <div className="relative mb-8 w-full"></div>
                        <h1 className="text-4xl font-bold text-gray-800 mb-4">You have not configured yet.</h1>
                        <p className="text-gray-500 mb-2">Lead Token for page is not Connected.</p>
                        <p className="text-gray-500 mb-8">Please Check The Url From following</p>
                        <div className="flex gap-4 w-full max-w-md justify-center">
                            <button className="py-3 px-8 bg-blue-500 text-white font-medium rounded">
                                GO TO ADD CONFIG
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const [inputFocused, setInputFocused] = useState(false);
    const [selectFocused, setSelectFocused] = useState(false);
    const [userId, setUserId] = useState('');
    const [businessInfo, setBusinessInfo] = useState(null);
    const [pages, setPages] = useState([]);
    const [selectedPageId, setSelectedPageId] = useState('');
    const [WAdata, setWAdata] = useState(null);
    const [leadOpen, setLeadOpen] = useState(false);
    const [leadPages, setLeadPages] = useState([]);
    const [adAccounts, setAdAccounts] = useState([]);
    const [selectedAdAccountId, setSelectedAdAccountId] = useState('');
    const [adAccountSelectFocused, setAdAccountSelectFocused] = useState(false);
    const [leadPageId, setLeadPageId] = useState("");
    // const [businessId, setSelectedBusinessId] = useState("");
    const [leadConnected, setLeadConnected] = useState(false);
    const [availablePages, setAvailablePages] = useState([]);
    const [selectedPageForBM, setSelectedPageForBM] = useState('');
    const [isCreatingChildBM, setIsCreatingChildBM] = useState(false);
    const [childBMCreated, setChildBMCreated] = useState(false);
    const [childBMId, setChildBMId] = useState('');
    const [pageSelectFocused, setPageSelectFocused] = useState(false);
    const styles = {
        container: {
            width: "100%",
            padding: "20px",
        },
        header: {
            display: "flex",
            alignItems: "center",
            marginBottom: "30px"
        },
        logo: {
            width: "47.1px",
            height: "31.3px",
            marginRight: "15px"
        },
        titleContainer: {
            display: "flex",
            flexDirection: "column"
        },
        title: {
            margin: "0",
            color: "#000",
            fontSize: "22px",
            fontWeight: "bold"
        },
        subtitle: {
            margin: "5px 0 0",
            color: "#65676B",
            fontSize: "14px"
        },
        section: {
            background: "#fff",
            borderRadius: "8px",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
            padding: "20px",
            marginBottom: "20px"
        },
        sectionTitle: {
            margin: "0",
            fontSize: "16px",
            fontWeight: "600"
        },
        sectionDescription: {
            margin: "5px 0 15px",
            color: "#65676B",
            fontSize: "14px"
        },
        flexContainer: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        },
        asterisk: {
            color: "red"
        },
        selectContainer: {
            position: "relative",
            width: "100%",
            maxWidth: "200px"
        },
        select: {
            width: "100%",
            padding: "10px 15px",
            borderRadius: "5px",
            border: `1px solid ${selectFocused ? colors.primary03 : '#ccc'}`,
            backgroundColor: "#fff",
            appearance: "none",
            fontSize: "14px",
            outline: "none"
        },
        selectArrow: {
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)"
        },
        inputContainer: {
            position: "relative",
            width: "100%",
            maxWidth: "545px",
            display: "flex",
            gap: "10px",
        },
        input: {
            flex: "1",
            padding: "10px 15px",
            borderRadius: "5px",
            border: `1px solid ${inputFocused ? colors.primary03 : '#ccc'}`,
            fontSize: "14px",
            outline: "none"
        },
        verifyButton: {
            backgroundColor: "#E4DBFD",
            color: "#8256D0",
            border: "none",
            borderRadius: "5px",
            padding: "0 20px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500"
        }
    };

    const fetchAdAccounts = async () => {
        try {
            const accountInsightsResponse = await getAdAccountInsights({ before: "", after: "" }, authtoken);
            if (accountInsightsResponse?.flag) {
                console.log("Ad Accounts:", accountInsightsResponse?.data);
                setAdAccounts(accountInsightsResponse?.data?.adAccounts?.data || []);
            } else {
                toast.error(accountInsightsResponse?.message || "Failed to fetch ad accounts");
            }
        } catch (err) {
            console.error("Error fetching ad accounts:", err);
            toast.error(err?.message || "An error occurred while fetching ad accounts");
        }
    };

    useEffect(() => {
        // Check if leads are connected
        if (localdata?.metaConfig?.leadsPageId) {
            setLeadConnected(true);

            // Fetch available pages if leads are already connected
            fetchPagesForChildBM();
        }

        // Check if child BM is already created
        if (localdata?.metaConfig?.childBMId && localdata?.metaConfig?.isChildBMAdded) {
            setChildBMCreated(true);
            setChildBMId(localdata.metaConfig.childBMId);
        }
    }, [authtoken, localdata]);

    useEffect(() => {
        // Check for lead page ID and save if it exists
        if (leadPageId) {
            console.log("SAVING LEAD PAGE");
            saveLeadPage();
        }
        // Get Meta Ads User Info
        getMetaAdsUserInfo(authtoken).then((res) => {
            try {
                if (res?.flag) {
                    console.log("Meta Ads User Info:", res?.data);
                    // Extract and store user ID
                    if (res?.data?.id) {
                        setUserId(res.data.id);
                        // Call business info API with the user ID
                        fetchBusinessInfo(res.data.id);
                    }
                } else {
                    toast.error(res?.message);
                }
            } catch (err) {
                toast.error(err?.message);
            }
        });
        // Fetch ad accounts
        fetchAdAccounts();
        // Check if leads are connected
        if (localdata?.metaConfig?.leadsPageId) {
            setLeadConnected(true);
        }
    }, [leadPageId]);

    const fetchPagesForChildBM = () => {
        getLeadPages(authtoken).then((res) => {
            try {
                if (res?.flag) {
                    setAvailablePages(res?.data?.data ?? res?.data);
                } else {
                    toast.error(res?.message);
                }
            } catch (err) {
                toast.error(err?.message);
            }
        });
    };

    const fetchBusinessInfo = (userId) => {
        if (!userId) return;

        const data = { userMetaId: userId };
        getMetauserBusinessInfo(data, authtoken)
            .then((res) => {
                try {
                    if (res?.flag) {
                        console.log("Meta User Business Info:", res?.data);

                        // Store the business info
                        setBusinessInfo(res.data);

                        // Extract pages from the response if available
                        if (res?.data?.data && Array.isArray(res.data.data)) {
                            setPages(res.data.data);
                        }
                        else {
                            toast.error(res?.message);
                        }
                    } else {
                        toast.error(res?.message);
                    }
                } catch (err) {
                    toast.error(err?.message);
                }
            });
    };

    const handlePageSelect = (e) => {
        const pageId = e.target.value;
        setSelectedPageId(pageId);
        const data = { selectedBusinessId: pageId };
        console.log(data);
        if (pageId !== "") {
            getMetauserWABusinessInfo(data, authtoken).then((res) => {
                try {
                    if (res?.flag) {
                        console.log("Meta Ads User Info:", res?.data);
                        setWAdata(res.data.data);
                    } else {
                        toast.error(res?.error);
                        setWAdata(null); // Set to null instead of empty array on error
                    }
                } catch (err) {
                    toast.error(err?.error);
                    setWAdata(null); // Set to null instead of empty array on error
                }
            });
        }
    };

    const handleConnectChildBM = async () => {
        if (!selectedPageForBM) {
            toast.error("Please select a Facebook page", { position: 'top-center' });
            return;
        }

        setIsCreatingChildBM(true);

        // Find the selected page to use its name
        const selectedPage = availablePages.find(page => page.id === selectedPageForBM);

        if (!selectedPage) {
            toast.error("Selected page not found", { position: 'top-center' });
            setIsCreatingChildBM(false);
            return;
        }

        const loadingToastId = toast.loading("Creating Business Manager...", {
            position: 'top-center',
        });

        try {
            const childBMData = {
                bmName: `${selectedPage.name} Child BM`, // Use page name as BM name
                shared_page_id: selectedPageForBM,
                adAccountName: `${selectedPage.name} Ad Account`,
                // Other parameters are handled by the backend
            };

            const response = await onboardTwoTierBusiness(childBMData, authtoken);

            if (response?.flag) {
                setChildBMCreated(true);
                setChildBMId(response.data?.id || '');
                toast.update(loadingToastId, {
                    render: 'Business Manager created successfully!',
                    type: 'success',
                    isLoading: false,
                    autoClose: 3000,
                    closeButton: true,
                });

                // Refresh user data to get updated meta configuration
                getUserApiCall();
            } else {
                toast.update(loadingToastId, {
                    render: response?.message || 'Failed to create Business Manager',
                    type: 'error',
                    isLoading: false,
                    autoClose: 3000,
                    closeButton: true,
                });
            }
        } catch (error) {
            console.error("Error creating Business Manager:", error);
            toast.error("An error occurred while creating Business Manager", { position: 'top-center' });
        } finally {
            setIsCreatingChildBM(false);
        }
    };

    // Lead management functions
    const getLeadsPagesListApiCall = () => {
        let token = authtoken;
        console.log("getting list of all pages api for leads");
        getLeadPages(token).then((res) => {
            try {
                if (res?.flag) {
                    setLeadPages(res?.data?.data ?? res?.data);
                    setLeadOpen(true);
                } else {
                    toast.error(res?.message);
                }
            } catch (err) {
                toast.error(err?.message);
            }
        });
    };

    const saveLeadPage = () => {
        const token = authtoken;
        const data = {
            pageId: leadPageId,
            businessId: businessId ?? "",
        }
        saveLeadPageId(token, data).then((res) => {
            try {
                if (res?.flag) {
                    setLeadPageId("");
                    getUserApiCall();
                    setLeadOpen(false);
                    setBusinessId("");
                    setLeadConnected(true);
                    toast.success("Successfully connected to Facebook Leads", { position: 'top-center' });

                    // After successful lead connection, fetch pages for child BM
                    fetchPagesForChildBM();
                } else {
                    toast.error(res?.message);
                }
            } catch (err) {
                toast.error(err?.message);
            }
        });
    }


    const handleConnectLeads = async () => {
        if (!window.FB) {
            toast.error("Facebook SDK not loaded. Please refresh the page.", { position: 'top-center' });
            return;
        }

        try {
            window.FB.login(
                (response) => {
                    if (response.authResponse) {
                        const fbToken = response.authResponse.accessToken;
                        saveFbToken({ token: fbToken }, authtoken)
                            .then((res) => {
                                if (res?.flag) {
                                    getLeadsPagesListApiCall();
                                } else {
                                    toast.error(res?.message, { position: 'top-center' });
                                }
                            })
                            .catch((e) => {
                                console.error("Error saving Facebook token:", e);
                                toast.error("Failed to save Facebook token", { position: 'top-center' });
                            });
                    } else {
                        console.log('User cancelled login or did not fully authorize.');
                        toast.warn("Login cancelled or not fully authorized", { position: 'top-center' });
                    }
                },
                {
                    scope: 'pages_show_list,ads_management,leads_retrieval,pages_read_engagement,read_insights,pages_manage_cta,ads_read,whatsapp_business_management,pages_read_user_content,pages_manage_engagement,whatsapp_business_messaging',
                }
            );
        } catch (error) {
            console.error('Error connecting Leads:', error);
            toast.error("Failed to connect Facebook Leads", { position: 'top-center' });
        }
    };

    const handleDisconnectLeads = () => {
        delinkFbToken(authtoken)
            .then((res) => {
                if (res?.flag) {
                    getUserApiCall();
                    setLeadConnected(false);
                    toast.success("Successfully delinked Facebook Leads", { position: 'top-center' });
                } else {
                    toast.error(res?.message || "Failed to delink Facebook Leads", { position: 'top-center' });
                }
            })
            .catch((error) => {
                console.error("Error delinking Facebook Leads:", error);
                toast.error("Failed to delink Facebook Leads", { position: 'top-center' });
            });
    };

    const getUserApiCall = () => {
        let token = authtoken;
        getUserApi(token).then((res) => {
            if (res?.flag) {
                dispatch({ type: 'addLocaldata', payload: res?.data });
            } else {
                navigate('/');
                toast.error(res?.message);
            }
        });
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <div>
                    <img src={images.MetaAdsManager} alt="Meta Logo" style={styles.logo} />
                </div>
                <div style={styles.titleContainer}>
                    <h2 style={styles.title}>Meta Ads Integration</h2>
                    <p style={styles.subtitle}>Run and automate your click to WhatsApp Ads from Cheerio</p>
                </div>
            </div>

            {/* Facebook Leads section */}
            <div style={styles.section}>
                <div>
                    <h3 style={styles.sectionTitle}>Connect your Facebook account</h3>
                    <p style={styles.sectionDescription}>To receive advertisement analytics and events from Facebook</p>
                </div>
                <div style={styles.flexContainer}>
                    <p><span style={styles.asterisk}>*</span>Please select <strong>OPT into all</strong> option for Business</p>
                    <CheerioButton
                        borderStyle={{ border: `1px solid ${colors.primary03}`, width: '10%' }}
                        textStyle={{ color: colors.primary03 }}
                        btnText={leadConnected ? 'Disconnect' : 'Connect'}
                        backColor={colors.white01}
                        onclick={() => {
                            if (leadConnected) {
                                handleDisconnectLeads();
                            } else {
                                handleConnectLeads();
                            }
                        }}
                    />
                </div>
            </div>
            {leadConnected && (
                <div style={styles.section}>
                    <div>
                        <h3 style={styles.sectionTitle}>Connect Business Manager</h3>
                        <p style={styles.sectionDescription}>
                            Create a Business Manager linked to your Facebook page
                        </p>
                    </div>

                    {childBMCreated ? (
                        <div style={styles.flexContainer}>
                            <p style={styles.childBMStatus}>
                                ✅ Business Manager connected successfully (ID: {childBMId})
                            </p>
                        </div>
                    ) : (
                        <div style={styles.flexContainer}>
                            <div style={styles.selectContainer}>
                                <FormControl fullWidth>
                                    <Select
                                        value={selectedPageForBM}
                                        onChange={(e) => setSelectedPageForBM(e.target.value)}
                                        onFocus={() => setPageSelectFocused(true)}
                                        onBlur={() => setPageSelectFocused(false)}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (!selected) {
                                                return "Select Facebook Page";
                                            }
                                            const selectedPage = availablePages.find(page => page.id === selected);
                                            return selectedPage ? selectedPage.name : '';
                                        }}
                                        sx={{
                                            width: "100%",
                                            borderRadius: "6px",
                                            backgroundColor: "#fff",
                                            fontSize: '0.875rem',
                                            height: '36px',
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: pageSelectFocused ? colors.primary03 : 'rgba(0, 0, 0, 0.1)',
                                                borderWidth: pageSelectFocused ? '1px' : '1px',
                                            }
                                        }}
                                        IconComponent={KeyboardArrowDownIcon}
                                    >
                                        <MenuItem value="" disabled>
                                            Select Facebook Page
                                        </MenuItem>
                                        {availablePages.map(page => (
                                            <MenuItem key={page.id} value={page.id}>
                                                {page.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            <CheerioButton
                                borderStyle={{ border: `1px solid ${colors.primary03}`, width: 'auto' }}
                                textStyle={{ color: colors.white01 }}
                                btnText={isCreatingChildBM ? 'Creating...' : 'Connect BM'}
                                backColor={colors.primary03}
                                onclick={handleConnectChildBM}
                                disabled={isCreatingChildBM || !selectedPageForBM}
                            />
                        </div>
                    )}
                </div>
            )}


            {/* Lead Page Selection Modal */}
            {leadOpen && (
                <SelectPageModal
                    setListPageModalOpen={setLeadOpen}
                    setSelectedPageId={setLeadPageId}
                    setSelectedBusinessId={setBusinessId}
                    pagesList={leadPages}
                    setPagesList={setLeadPages}
                    type={"leads"}
                />
            )}
            {leadConnected && (
                <div style={styles.section}>
                    <div style={{ ...styles.sectionTitle }}>
                        <h3>To link WhatsApp account with this page, please complete following steps:</h3>
                        <ol style={{ marginTop: "10px", lineHeight: "1.5" }}>
                            <li>Login to your Page</li>
                            <li>Click on <a href="https://www.facebook.com/settings/?tab=linked_whatsapp" target="_blank" rel="noopener noreferrer" style={{ color: colors.primary03 }}>this link</a></li>
                            <li>Proceed to complete registration</li>
                        </ol>
                    </div>
                </div>
            )}
            {/* Facebook page selection section */}
            {/* <div style={styles.section}>
                <div style={styles.flexContainer}>
                    <div>
                        <h3 style={styles.sectionTitle}>Choose your Facebook page</h3>
                        <p style={styles.sectionDescription}>Select Facebook page to run ad</p>
                    </div>
                    <FormControl size="small" sx={{ minWidth: 150 }}>
                        <Select
                            value={selectedPageId}
                            onChange={handlePageSelect}
                            onFocus={() => setSelectFocused(true)}
                            onBlur={() => setSelectFocused(false)}
                            displayEmpty
                            renderValue={(selected) => {
                                if (!selected) {
                                    return "Select page";
                                }
                                const selectedPage = pages.find(page => page.id === selected);
                                return selectedPage ? selectedPage.name : '';
                            }}
                            sx={{
                                width: "100%",
                                borderRadius: "6px",
                                backgroundColor: "#fff",
                                fontSize: '0.875rem',
                                height: '36px',
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: selectFocused ? colors.primary03 : 'rgba(0, 0, 0, 0.1)',
                                    borderWidth: selectFocused ? '1px' : '1px',
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: selectFocused ? colors.primary03 : 'rgba(0, 0, 0, 0.2)',
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: colors.primary03,
                                }
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 200,
                                        mt: 0.5
                                    }
                                }
                            }}
                        >
                            <MenuItem value="" disabled>
                                Select page
                            </MenuItem>
                            {pages.map(page => (
                                <MenuItem key={page.id} value={page.id}>
                                    {page.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
            </div> */}

            {/* WhatsApp number linking section */}
            {/* {WAdata && WAdata.length > 0 ? (
                <div style={styles.section}>
                    <div style={styles.flexContainer}>
                        <div>
                            <h3 style={styles.sectionTitle}>Link WhatsApp Number</h3>
                            <p style={styles.sectionDescription}>Link with selected Facebook page to receive messages directly over WhatsApp</p>
                        </div>
                        <FormControl size="small" sx={{ minWidth: 150 }}>
                            <Select
                                value={phoneNumber}
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                onFocus={() => setSelectFocused(true)}
                                onBlur={() => setSelectFocused(false)}
                                displayEmpty
                                renderValue={(selected) => {
                                    if (!selected) {
                                        return "Select WhatsApp Number";
                                    }
                                    const selectedNumber = WAdata?.find(number => number.id === selected);
                                    return selectedNumber ? (selectedNumber.display_phone_number || selectedNumber.phone_number) : '';
                                }}
                                sx={{
                                    width: "100%",
                                    borderRadius: "6px",
                                    backgroundColor: "#fff",
                                    fontSize: '0.875rem',
                                    height: '36px',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: selectFocused ? colors.primary03 : 'rgba(0, 0, 0, 0.1)',
                                        borderWidth: selectFocused ? '1px' : '1px',
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: selectFocused ? colors.primary03 : 'rgba(0, 0, 0, 0.2)',
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: colors.primary03,
                                    }
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            maxHeight: 200,
                                            mt: 0.5
                                        }
                                    }
                                }}
                            >
                                <MenuItem value="" disabled>
                                    Select WhatsApp Number
                                </MenuItem>
                                {WAdata?.map(number => (
                                    <MenuItem key={number.id} value={number.id}>
                                        {number.display_phone_number || number.phone_number}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>
            ) : (
                // Only show this warning when WAdata exists (not null) but is empty
                Array.isArray(WAdata) && WAdata.length === 0 && (
                    <div style={styles.section}>
                        <div style={{ ...styles.sectionTitle }}>
                            <h3>There is no WhatsApp account linked with this page, please complete following steps to link one:</h3>
                            <ol style={{ marginTop: "10px", lineHeight: "1.5" }}>
                                <li>Login to your Page</li>
                                <li>Click on <a href="https://www.facebook.com/settings/?tab=linked_whatsapp" target="_blank" rel="noopener noreferrer" style={{ color: colors.primary03 }}>this link</a></li>
                                <li>Proceed to complete registration</li>
                            </ol>
                        </div>
                    </div>
                )
            )} */}
        </div>
    );
};